var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { UXPContext } from '@core/context/Context';
import Modal from '@widget/popups/Modal';
import DynamicForm from '@widget/forms/DynamicForm/DynamicForm';
import { convertToNewFormStructure, loadAllScriptsByModuleId, lookupComponent } from '@utils';
import { hasValue } from '@utils';
/**
 * Modal for editing a pluggable view's configuration props.
 * @export
 *
 * @advanced
 */
const PluggableViewConfig = ({ componentId, currentProps, onClose, onSave }) => {
    const context = useContext(UXPContext);
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        if (!hasValue(componentId)) {
            setLoaded(true);
            return;
        }
        const registered = lookupComponent(componentId);
        if (registered) {
            setLoaded(true);
            return;
        }
        setLoading(true);
        loadAllScriptsByModuleId(context, componentId)
            .finally(() => {
            setLoading(false);
            setLoaded(true);
        });
    }, [componentId]);
    const { formStructure, ConfigPanel } = useMemo(() => {
        var _a, _b, _c;
        if (!hasValue(componentId) || !loaded) {
            return { formStructure: [], ConfigPanel: null };
        }
        const registered = lookupComponent(componentId);
        if (!registered) {
            return { formStructure: [], ConfigPanel: null };
        }
        const configProps = ((_a = registered.configs) === null || _a === void 0 ? void 0 : _a.props) || [];
        const seeded = configProps.map((field) => (Object.assign(Object.assign({}, field), { value: field.name in currentProps ? currentProps[field.name] : field.value })));
        return {
            formStructure: seeded,
            ConfigPanel: (_c = (_b = registered.configs) === null || _b === void 0 ? void 0 : _b.configPanel) !== null && _c !== void 0 ? _c : null
        };
    }, [componentId, loaded, currentProps]);
    const handleSave = useCallback((submittedData) => __awaiter(void 0, void 0, void 0, function* () {
        onSave(Object.assign(Object.assign({}, (currentProps !== null && currentProps !== void 0 ? currentProps : {})), submittedData));
    }), [currentProps, onSave]);
    const renderContent = () => {
        if (!hasValue(componentId))
            return null;
        if (loading || !loaded) {
            return _jsx("div", { className: "uxpcore_pvc__loading", children: context.$L('uxp-core.text.loading') });
        }
        if (ConfigPanel) {
            return (_jsx(ConfigPanel, { configs: currentProps, onSubmit: handleSave, onCancel: onClose, uxpContext: context }));
        }
        if (formStructure.length > 0) {
            return (_jsx(DynamicForm, { formStructure: convertToNewFormStructure(formStructure), onSubmit: handleSave, onCancel: onClose }));
        }
        return (_jsx("div", { className: "uxpcore_pvc__noconfig", children: _jsx("p", { children: context.$L('uxp-core.text.no-configuration-available') }) }));
    };
    return (_jsx(Modal, { show: hasValue(componentId), title: context.$L('uxp-core.text.edit-configuration'), onClose: onClose, autoSize: true, className: "uxpcore_pvc__modal", children: renderContent() }));
};
export default PluggableViewConfig;
